import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Body, Box, Heading, Link } from '@hover/blueprint';
import { SharedFaq } from '../common';
import { INDEPENDENT_ADJUSTERS_FAQ } from '../../constants/independentAdjusters';

const FAQ: React.FC = () => (
  <Box
    w="100%"
    flexDir="column"
    alignItems="center"
    pt={{ base: 700, tablet: 0 }}
    pb={{ base: 700, tablet: 1000 }}
    px={{ base: '500', tablet: '56px' }}
  >
    <Heading
      as="h2"
      isLight
      size={{ base: 500, tablet: 600, desktop: 700 }}
      marginBottom={{ base: 800, tablet: '88px', desktop: '88px' }}
    >
      Frequently asked questions
    </Heading>
    <SharedFaq questions={INDEPENDENT_ADJUSTERS_FAQ} />

    <Body size={500} fontWeight={300} mt={600}>
      Still have questions? Never hesitate to contact{' '}
      <Link href="mailto:support@hover.to" fontWeight={600}>
        Support
      </Link>
      .
    </Body>
  </Box>
);

export default FAQ;
